import React, {useState} from 'react';
import "./qualification.css"

const Qualification = () =>{

    const [toggleState, setToggleState]= useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    }
    return(
        <section className="qualification section" id='qualification'>
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My Journey</span>



            <div className="qualification__container container"> 
                <div className="qualification__tabs">
                    <div onClick={ () => toggleTab(1)} className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}>
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                    </div>

                    <div onClick={ () => toggleTab(2)} className={toggleState === 2 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                    </div>
                </div>

                <div className="qualification__sections">
                    <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">Software Engineer</h3>
                                <span className="qualification__subtitle">Tunis - ESPRIT-HONORIS</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>2021-Present
                                </div>
                                
                            </div>
                            
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">High School Baccalaureat</h3>
                                <span className="qualification__subtitle">Lycée privé Amilcar 2</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>2017-2021
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">Middle School Diploma</h3>
                                <span className="qualification__subtitle">Collège privé Laghmani</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>2014-2017
                                </div>
                            </div>
                            
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Elementary School</h3>
                                <span className="qualification__subtitle">École primaire Laghmani</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>2007-2014
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                    </div>

                    
                    <div  className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
                    
                        <div className="qualification__data">
                    
                            <div>
                                <h3 className="qualification__title">MCYM GROUP</h3>
                                <span className="qualification__subtitle">Co-Founder & Head Of Operations</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>August 2025-Present
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">Neolians</h3>
                                <span className="qualification__subtitle">AI Intern</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>June 2025-August 2025
                                </div>
                            </div>
                            
                        </div>
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">YOPEX.AI</h3>
                                <span className="qualification__subtitle">Co-Founder & Full Stack Developer</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>April 2025 - Present
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">APAIA</h3>
                                <span className="qualification__subtitle">AI Intern</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>June 2024-July 2024
                                </div>
                            </div>
                            
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Tunisian Cloud</h3>
                                <span className="qualification__subtitle">AI Intern</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>July 2024-August 2024
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                        
                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">KHConsulting</h3>
                                <span className="qualification__subtitle">IT Intern</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i>August 2022-September 2022
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Qualification